import React from 'react';
import PropTypes from 'prop-types';

export default function Check(props) {
  return (
    <svg viewBox="0 0 24 24" width={props.width} height={props.width} stroke={props.color} strokeWidth={props.strokeWidth} fill="none" strokeLinecap="round" strokeLinejoin="round"><polyline points="20 6 9 17 4 12"></polyline></svg>
  );
}

Check.propTypes = {
  color: PropTypes.string,
  width: PropTypes.number,
  strokeWidth: PropTypes.number,
};

Check.defaultProps = {
  color: '#202020',
  width: 24,
  strokeWidth: 4,
};